import { useState, useEffect, useCallback } from 'react';

const useOverscroll = ({ threshold = -10, onOverscroll, onReset } = {}) => {
    const [isOverscrolling, setIsOverscrolling] = useState(false);

    const handleScroll = useCallback(() => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop < threshold && !isOverscrolling) {
            setIsOverscrolling(true);
            onOverscroll?.({
                scrollTop,
                timestamp: Date.now()
            });
        } else if (scrollTop >= 0 && isOverscrolling) {
            setIsOverscrolling(false);
            onReset?.({
                scrollTop,
                timestamp: Date.now()
            });
        }
    }, [threshold, isOverscrolling, onOverscroll, onReset]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    return { isOverscrolling };
};

export default useOverscroll;